<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'strategicContractDetail',
    components: {
      baseEdit,
    },
  };
</script>
